// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import ResourceLinkSchema from './resource-link-schema';

const schema = {
  $id: '/membership-open-invoice-list-schema',
  type: 'object',
  required: ['amountInvoiced', 'amountOutstanding'],
  nullable: true,
  properties: {
    id: {
      type: 'string',
      format: 'uuid',
    },
    links: {
      type: 'array',
      nullable: true,
      items: { ...ResourceLinkSchema },
    },
    subject: {
      type: 'string',
      nullable: true,
    },
    businessDivision: {
      type: 'string',
      nullable: true,
    },
    invoiceDate: {
      type: 'string',
      format: 'date-time',
      nullable: true,
    },
    dueDate: {
      type: 'string',
      format: 'date-time',
      nullable: true,
    },
    currency: {
      type: 'string',
      nullable: true,
    },
    amountInvoiced: {
      type: 'number',
    },
    amountOutstanding: {
      type: 'number',
    },
  },
} as IJSONSchema;

export default schema;
